export default function updateState(data, array, setArray) {
    const index = array.findIndex((doc) => doc.id === data.id);
    const newArray = [...array];
    newArray[index] = { ...data };
    setArray(newArray);
}
